import { baseAxios } from "../index";

export async function getAllPengajuanKoorProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({ type: "SET_ALL_PENGAJUAN_PRODUKTIF", data: response.data });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function ambilTotalDitolakProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_AMBIL_DITOLAK_PRODUKTIF",
      data: response.data.totalDocs,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function ambilTotalDiajukanProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_AMBIL_DIAJUKAN_PRODUKTIF",
      data: response.data.totalDocs,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function ambilTotalPengajuanProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_AMBIL_DISETUJUI_PRODUKTIF",
      data: response.data.totalDocs,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function ambilDiprosesProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_AMBIL_DIPROSES_PRODUKTIF",
      data: response.data.totalDocs,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function ambilGagalTerkirimProduktif(dispatch, data, history) {
  try {
    const response = await baseAxios.get(
      `webPengajuanProduktif/getPengajuanKoor?page=${data.page}&limit=${data.limit}&cari=${data.cari}&statusPengajuan=${data.statusPengajuan}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );

    dispatch({
      type: "SET_AMBIL_GAGALTERKIRIM_PRODUKTIF",
      data: response.data.totalDocs,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function pengajuanBPDProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webApiBpd/pengajuanProduktif",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function revisiPengajuanDariKoorProduktif(data) {
  try {
    const response = await baseAxios.post(
      "webPengajuanProduktif/ubahRevisi",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function getListKategoriJsonKoorProduktif(
  dispatch,
  data,
  history
) {
  try {
    const response = await baseAxios.get(`mobileListJson/allJson`);
    dispatch({
      type: "SET_GET_LIST_KATEGORI_KOOR_JSON",
      data: response.data,
    });
    return response.status;
  } catch (err) {
    return err.response;
  }
}
